const it = {
  // Navbar
  nav_home: "Home",
  nav_about: "Chi è Tenten-Ojisan",
  nav_services: "Servizi e Prezzi",
  nav_flow: "Come Funziona",
  nav_testimonials: "Testimonianze",
  nav_faq: "Domande Frequenti",
  nav_contact: "Contatti",
  nav_cta: "Prenota una Lettura",
  nav_subtitle: "Lettura del Nome · Okinawa",
  nav_title: "Tenten-Ojisan Divinazione",

  // Hero
  hero_headline1: "Su un'isola silenziosa",
  hero_headline2: "di Okinawa,",
  hero_headline3: "ascolta la voce",
  hero_headline4: "del tuo nome.",
  hero_body: "Una lettura del nome amatissima, con mesi di attesa.\nOgni mese vado sull'isola al posto tuo\ne consegno personalmente il tuo nome al maestro.",
  hero_pill1: "Nessun cambio di nome",
  hero_pill2: "100% online",
  hero_pill3: "Consegnato entro 1 mese",
  hero_pill4: "Primi 100 al mese",
  hero_btn_apply: "Prenota una Lettura",
  hero_btn_services: "Vedi i Servizi",
  hero_scroll: "SCORRI",

  // About
  about_heading: "Chi è Tenten-Ojisan",
  about_intro: "Sull'isola tranquilla di <strong>Ikei-jima</strong>, avvolta dal dolce mare di Okinawa,\nc'è un uomo che aggiunge silenziosamente luce al nome di ogni persona.\nLe persone lo chiamano affettuosamente <strong>\"Tenten-Ojisan\"</strong>.",
  about_block1_label: "Da Banchiere a Lettore di Nomi",
  about_block1_text: "Tenten-Ojisan era originariamente un banchiere.\nGrazie alla sua dedizione, divenne il <strong>più giovane direttore di filiale</strong> della sua azienda.\nLavorando con molte persone, nacque nel suo cuore una domanda.",
  about_block1_quote: "\"Perché alcune persone sembrano avere il vento in poppa, anche quando tutti lavorano con la stessa intensità?\"",
  about_block1_sub: "Quella piccola domanda divenne l'inizio di un grande viaggio di scoperta.",
  about_block2_label: "Saggezza Antica e una Rivelazione Silenziosa",
  about_block2_text: "Dedicò ogni momento libero allo studio di antichi testi sulla lettura dei nomi, ricercando attentamente il numero di tratti dei caratteri tradizionali e il flusso dei suoni.",
  about_block2_text2: "Giunse a capire che <strong>\"i ten-ten (segni sonori) possono armonizzare silenziosamente il flusso di un nome.\"</strong>",
  about_block2_sub: "Non era magia drammatica né una formula di successo appariscente,\nma un modo gentile di rendere più visibile la luce già presente in una persona.",
  about_block3_label: "Passaparola, Ora con 6 Mesi di Attesa",
  about_block3_text: "Le sue letture gentili si sono diffuse solo tramite passaparola, e ora <strong>arrivano richieste da tutto il Giappone</strong>.\nFamosi o meno, tratta ogni persona con la stessa cura.\nPosa la mano su ogni nome e cammina accanto alla vita di quella persona.\nQuesto è lo stile di Tenten-Ojisan.",

  // Gallery
  gallery_heading: "Galleria",
  gallery_sub: "Okinawa · Isola di Ikei",

  // Services
  services_heading: "Servizi e Prezzi",
  services_note1: "※ Tutte le tariffe includono il compenso del maestro e il servizio di rappresentanza in loco.",
  services_note2: "※ Nessun costo aggiuntivo. Affidatevi a noi con fiducia.",
  services_tab1: "Nome Personale",
  services_tab2: "Nome Aziendale",
  services_tab3: "Nome dell'Animale",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Osservando delicatamente la crescita, l'ambiente e i movimenti del cuore, aggiungiamo il ten-ten perfetto per te.",
  services_tab2_desc: "Un vento favorevole per le nuove sfide. Armonizzando dolcemente il flusso della tua attività.",
  services_tab3_desc: "Per il membro della famiglia sempre al tuo fianco. Consegniamo un nome pieno di pace e calore.",
  services_row1_target1: "16 anni e oltre",
  services_row1_target2: "4–15 anni",
  services_row1_target3: "0–3 anni",
  services_row2_target1: "Negozio / Azienda / Nome Commerciale",
  services_row3_target1: "Nome dell'Animale",
  services_col_target: "Destinatario",
  services_col_price: "Prezzo (IVA incl.)",
  services_cta: "Richiedi Questo Servizio",
  services_includes_title: "Cosa è Incluso (tutto nella tariffa)",
  services_inc1: "Lettura del nome",
  services_inc2: "Suggerimento ottimale del ten-ten",
  services_inc3: "Cartoncino formato biglietto da visita spedito su richiesta (gratuito)",
  services_inc4: "Consigli per la buona fortuna",
  services_inc5: "Foto digitale del cartoncino con il nome",
  services_includes_note: "Una lettura per far emergere delicatamente il fascino già presente nel tuo nome.",
  services_payment_title: "Pagamento",
  services_payment_method: "Bonifico Bancario (pagamento anticipato)",
  services_payment_desc: "Forniremo i dettagli bancari dopo la tua richiesta.\nDal momento in cui il pagamento è completato, il flusso della fortuna inizia silenziosamente ad allinearsi.",
  services_first_title: "Per i Nuovi Visitatori",
  services_first_desc: "È naturale sentirsi incerti.\nQuella sensazione è un segnale del tuo cuore\nche è tempo di iniziare un cambiamento gentile.",
  services_first_cta: "Inizia con una Consulenza",

  // Flow
  flow_heading: "Come Funziona",
  flow_step1_title: "Invia il Modulo di Richiesta",
  flow_step1_c1: "Compila le informazioni richieste nel modulo dedicato.",
  flow_step1_c2: "Dopo l'invio, riceverai un'email di risposta entro 2–3 giorni lavorativi.",
  flow_step1_c3: "L'email includerà i prossimi passi e le istruzioni per il bonifico bancario.",
  flow_step2_title: "Trasferisci la Tariffa di Lettura",
  flow_step2_c1: "Trasferisci la tariffa di lettura al conto indicato nell'email di risposta.",
  flow_step2_c2: "Una volta confermato, inizieremo a preparare la tua lettura in ordine.",
  flow_step3_title: "Comunicaci il Tuo Trasferimento",
  flow_step3_c1: "Dopo il trasferimento, invia una foto della ricevuta all'indirizzo indicato nell'email.",
  flow_step3_c2: "Una volta confermato, ti invieremo un messaggio di \"Registrazione Completata\".",
  flow_step3_note: "Senza questa notifica, potremmo non essere in grado di iniziare la tua lettura. Assicurati di inviarla.",
  flow_step4_title: "Ricevi i Risultati della Lettura",
  flow_step4_c1: "Entro circa una settimana dalla lettura, ti invieremo via email una foto del tuo cartoncino con il nome e il ten-ten.",
  flow_step4_c2: "Invieremo poi un rapporto dettagliato della lettura e consigli per la buona fortuna via email.",
  flow_step5_title: "Spedizione del Cartoncino (Opzionale)",
  flow_step5_c1: "Su richiesta, spediremo un cartoncino formato biglietto da visita scritto a mano dal maestro.",
  flow_step5_c2: "Inserisci il tuo indirizzo postale esatto nel campo indirizzo del modulo di richiesta.",
  flow_step5_note: "Se non hai bisogno del cartoncino, è sufficiente inserire solo la città.",
  flow_banner_title: "Completamente online. Da qualsiasi parte del Giappone.",
  flow_banner_desc: "Non è necessario recarsi sull'isola di Ikei a Okinawa.\nPuoi iniziare così come sei, senza cambiare la tua vita quotidiana.",
  flow_banner_cta: "Richiedi Ora",

  // Testimonials
  testimonials_heading: "Testimonianze",
  testimonials_viewing: "Visualizzazione",

  // FAQ
  faq_heading: "Domande Frequenti",
  faq_cta_title: "Hai ancora domande?",
  faq_cta_desc: "Anche le piccole cose sono benvenute.\nLe domande che esiti a fare sono esattamente quelle che vogliamo sentire.",
  faq_cta_btn: "Chiedici Pure",

  // CTA Banner
  cta_heading1: "Consulenza",
  cta_heading2: "Gratuita",
  cta_btn: "Prenota Ora",

  // Contact
  contact_heading: "Contattaci",
  contact_desc: "Contattaci tramite questo modulo per richieste di lettura o domande. Di solito rispondiamo entro 2–3 giorni lavorativi.",
  contact_address_label: "Indirizzo",
  contact_address_value: "Tochigi, Giappone (Online · Tutto il Paese)",
  contact_email_label: "Email",
  contact_hours_label: "Orari",
  contact_hours_value: "Giorni feriali 9:00–18:00 (Chiuso Sab/Dom/Festivi)",
  contact_note_title: "Informazioni sulle Risposte",
  contact_note_desc: "La nostra risposta potrebbe finire nella cartella spam.\nSe non hai ricevuto risposta dopo 2–3 giorni lavorativi, contattaci direttamente via email.",
  contact_field_name: "Nome Completo",
  contact_field_furigana: "Furigana (Lettura)",
  contact_field_email: "Indirizzo Email",
  contact_field_phone: "Numero di Telefono",
  contact_field_service: "Servizio Desiderato",
  contact_field_message: "Messaggio",
  contact_placeholder_name: "Mario Rossi",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "esempio@email.com",
  contact_placeholder_phone: "+39 000 0000000",
  contact_placeholder_message: "Inserisci il nome che desideri far leggere, o qualsiasi domanda o richiesta.",
  contact_select_placeholder: "Seleziona",
  contact_service1: "Nome Personale",
  contact_service2: "Nome Aziendale",
  contact_service3: "Nome dell'Animale",
  contact_service4: "Altro / Consulenza",
  contact_submit: "Invia",
  contact_submitting: "Invio in corso...",
  contact_privacy: "Le informazioni personali inviate saranno utilizzate solo per i servizi di lettura.",
  contact_error: "Invio fallito. Riprova più tardi o contattaci direttamente via email.",
  contact_err_name: "Inserisci il tuo nome",
  contact_err_email_required: "Inserisci il tuo indirizzo email",
  contact_err_email_invalid: "Inserisci un indirizzo email valido",
  contact_err_service: "Seleziona un servizio",
  contact_err_message_required: "Inserisci il tuo messaggio",
  contact_err_message_limit: "Mantieni il messaggio entro 500 caratteri",
  contact_thanks_title: "Messaggio Inviato",
  contact_thanks_desc: "Grazie per averci contattato.\nEsamineremo il tuo messaggio e risponderemo entro <strong>2–3 giorni lavorativi</strong>.\nAttendi un momento.",
  contact_thanks_check1: "Controlla la tua email di conferma",
  contact_thanks_check2: "Controlla anche la cartella spam",
  contact_thanks_check3: "Attendi 2–3 giorni lavorativi per una risposta",
  contact_thanks_another: "Invia un altro messaggio",

  // Footer
  footer_subtitle: "Lettura del Nome · Okinawa",
  footer_title: "Tenten-Ojisan Divinazione",
  footer_desc: "Da Okinawa a tutto il Giappone. Un maestro della lettura dei nomi con oltre 50 anni di esperienza legge attentamente il destino nel tuo nome.",
  footer_contact_title: "INFORMAZIONI DI CONTATTO",
  footer_address_label: "INDIRIZZO",
  footer_address_value: "Tochigi, Giappone\n(Online · Tutto il Paese)",
  footer_email_label: "EMAIL",
  footer_hours_label: "ORARI",
  footer_hours_value: "Giorni feriali 9:00–18:00\n(Chiuso Sab/Dom/Festivi)",
  footer_nav_title: "NAVIGAZIONE",
  footer_copyright: "© 2025 Tenten-Ojisan Divinazione. Tutti i diritti riservati.",
  footer_privacy: "Informativa sulla Privacy",
  footer_law: "Legge sulle Transazioni Commerciali Specificate",
  footer_sitemap: "Mappa del Sito",
};

export default it;
